export default __webpack_public_path__ + "0248f6d2d5415b1b62d04c57a3de4f9924ab6676/4bca7c828ddf6f2ef86681e533b2f019.png";